import { Heart, Search, Sparkles, User, SlidersHorizontal } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
type Props = {
  query: string;
  onQuery: (v: string) => void;
  favCount: number;
  onCategory: (c: string) => void;
  categories: string[];
  onOpenFilters?: () => void;
};

export function Header({ query, onQuery, favCount, onCategory, categories, onOpenFilters }: Props) {
  return (
    <header className="sticky top-0 z-40 border-b border-border/60 bg-background/85 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center gap-4 px-4 py-3 md:px-6">
        <a href="#" className="flex shrink-0 items-center" aria-label="Achados do Dia">
          <img
            src="/logo-badge.webp"
            alt="Achados do Dia"
            width={208}
            height={112}
            fetchPriority="high"
            className="h-12 w-auto md:h-14 rounded-2xl shadow-[var(--shadow-soft)]"
          />
        </a>

        <div className="relative ml-2 hidden flex-1 md:block">
          <Search className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
          <Input
            value={query}
            onChange={(e) => onQuery(e.target.value)}
            placeholder="Busque por bolsas, maquiagens, acessórios..."
            className="h-11 rounded-full border-border bg-muted/60 pl-11 pr-4 text-sm placeholder:text-muted-foreground/70 focus-visible:ring-primary/40"
          />
        </div>

        <Button variant="ghost" size="icon" className="relative rounded-full" aria-label="Favoritos">
          <Heart className="h-5 w-5" />
          {favCount > 0 && (
            <span className="absolute -right-0.5 -top-0.5 grid h-4 min-w-4 place-items-center rounded-full bg-primary px-1 text-[10px] font-semibold text-primary-foreground">
              {favCount}
            </span>
          )}
        </Button>
        <Button variant="ghost" size="icon" className="hidden rounded-full sm:inline-flex" aria-label="Perfil">
          <User className="h-5 w-5" />
        </Button>
        <Button className="hidden rounded-full bg-[image:var(--gradient-primary)] px-5 shadow-[var(--shadow-soft)] hover:opacity-95 lg:inline-flex">
          <Sparkles className="mr-1.5 h-4 w-4" /> Ofertas de hoje
        </Button>
      </div>

      {/* Mobile search */}
      <div className="px-4 pb-3 md:hidden">
        <div className="relative">
          <Search className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
          <Input
            value={query}
            onChange={(e) => onQuery(e.target.value)}
            placeholder="Busque por bolsas, maquiagens..."
            className="h-11 rounded-full border-border bg-muted/60 pl-11"
          />
        </div>
      </div>

      {/* Category strip */}
      <nav aria-label="Categorias" className="border-t border-border/60 bg-background/60">
        <div className="mx-auto flex max-w-7xl items-center gap-1 overflow-x-auto px-3 py-2 text-sm md:px-6 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {onOpenFilters && (
            <button
              onClick={onOpenFilters}
              className="mr-1 inline-flex shrink-0 items-center gap-1.5 rounded-full px-3 py-1.5 text-foreground/70 hover:bg-secondary md:hidden"
            >
              <SlidersHorizontal className="h-4 w-4" /> Filtros
            </button>
          )}
          {["Todos", ...categories].map((c) => (
            <button
              key={c}
              onClick={() => onCategory(c === "Todos" ? "" : c)}
              className="shrink-0 rounded-full px-3.5 py-1.5 text-foreground/75 transition hover:bg-secondary hover:text-foreground"
            >
              {c}
            </button>
          ))}
        </div>
      </nav>
    </header>
  );
}
